<template>
  <div class="container page funds-page">
    <van-nav-bar :title="$t('frontend.funds.card_title')" class="nav-bar">
      <template #left>
        <button type="button" class="funds-back" :aria-label="$t('frontend.funds.back_funds')" @click="$router.push('/Setbank')">
          <van-icon name="arrow-left" color="#fff" />
        </button>
      </template>
    </van-nav-bar>

    <main class="funds-form">
      <div v-if="loading" class="funds-status" role="status">{{ $t('common.loading') }}</div>
      <div v-else-if="loadError" class="funds-status" role="alert">
        {{ loadError }}
        <van-button size="small" @click="load">{{ $t('common.retry') }}</van-button>
      </div>
      <form v-else @submit.prevent="save">
        <p class="funds-note">{{ $t('frontend.funds.card_note') }}</p>
        <div v-for="field in fields" :key="field.key" class="funds-field">
          <label :for="'bank-' + field.key">
            {{ $t(field.label) }}
            <span v-if="isBound" class="funds-field__status">{{ $t('setting.bindinged') }}</span>
          </label>
          <input
            :id="'bank-' + field.key"
            v-model.trim="form[field.key]"
            :type="field.type"
            :inputmode="field.inputmode"
            :maxlength="field.maxlength"
            :placeholder="$t(field.placeholder)"
            :readonly="isBound"
            :disabled="submitting"
            :autocomplete="field.autocomplete"
          />
        </div>
        <p class="funds-note warning-note">{{$t('setting.bank_warn')}}</p>
        <van-button
          class="funds-submit"
          block
          native-type="submit"
          :loading="submitting"
          :disabled="isBound"
          :loading-text="$t('frontend.funds.saving')"
        >{{ isBound ? $t('setting.bindinged') : $t('frontend.funds.confirm_bind') }}</van-button>
        <p v-if="isBound" class="funds-note binding-note">{{ $t('frontend.funds.card_bound_note') }}</p>
      </form>
    </main>
  </div>
</template>

<script>
import { bindingData, bindingError } from '../../common/binding';

const emptyBank = () => ({
  username: '',
  bank: '',
  bankid: ''
});

export default {
  data: () => ({
    loading: true,
    loadError: '',
    submitting: false,
    isBound: false,
    form: emptyBank(),
    fields: [
      { key: 'username', label: 'setting.username', placeholder: 'setting.username_place', type: 'text', maxlength: 255, autocomplete: 'name' },
      { key: 'bank', label: 'setting.band_name', placeholder: 'frontend.funds.bank_placeholder', type: 'text', maxlength: 20, autocomplete: 'organization' },
      { key: 'bankid', label: 'setting.band_account', placeholder: 'frontend.funds.card_placeholder', type: 'text', inputmode: 'numeric', maxlength: 30, autocomplete: 'off' }
    ]
  }),
  methods: {
    applyBinding(data) {
      const info = data && data.info && typeof data.info === 'object' ? data.info : null;
      if (!data || !data.is_bank || !info) {
        this.isBound = false;
        this.form = emptyBank();
        return;
      }
      this.form = {
        username: String(info.username || ''),
        bank: String(info.bankinfo || info.bank || ''),
        bankid: String(info.bankid || '')
      };
      this.isBound = true;
    },
    async load() {
      this.loading = true;
      this.loadError = '';
      try {
        const response = await this.$http({ method: 'get', url: 'user_get_bank' });
        this.applyBinding(bindingData(response));
      } catch (error) {
        this.loadError = error.message || this.$t('frontend.funds.card_load_failed');
        bindingError(this, error, this.loadError);
      } finally {
        this.loading = false;
      }
    },
    validate() {
      const values = {};
      Object.keys(this.form).forEach(key => { values[key] = String(this.form[key] || '').trim(); });
      if (!values.username) return this.$t('setting.username_place');
      if (!values.bank) return this.$t('frontend.funds.bank_placeholder');
      if (!/^\d{6,30}$/.test(values.bankid)) return this.$t('frontend.funds.card_number_invalid');
      if (values.username.length > 255 || values.bank.length > 20) {
        return this.$t('frontend.funds.card_too_long');
      }
      this.form = values;
      return '';
    },
    async save() {
      if (this.loading || this.loadError || this.submitting || this.isBound) return;
      const validationError = this.validate();
      if (validationError) {
        this.$toast(validationError);
        return;
      }
      this.submitting = true;
      try {
        const response = await this.$http({
          method: 'post',
          url: 'user_set_bank',
          data: {
            username: this.form.username,
            bank: this.form.bank,
            bankid: this.form.bankid
          }
        });
        const data = bindingData(response);
        this.applyBinding(data);
        this.$toast(this.$t('frontend.funds.card_success'));
      } catch (error) {
        bindingError(this, error, this.$t('frontend.funds.card_failed'));
      } finally {
        this.submitting = false;
      }
    }
  },
  created() {
    if (!localStorage.getItem('token')) this.$router.replace('/Login');
    else this.load();
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
@import "../../assets/css/funds.less";
.warning-note { color: #e0365f; }
.binding-note { margin-top: 28px; }
</style>
